<template>
  <div>
    <dl>
      <dt>구매 대상</dt>
      <dd>
        {{ convertCodeToName(item.target, TARGET_NAME_ENUM) }}
      </dd>
    </dl>
    <dl>
      <dt>현재 이용 내역</dt>
      <dd>{{ item.telecomName }} / {{ currentModelName }}</dd>
    </dl>
    <dl>
      <dt>단말기</dt>
      <dd>{{ item.needModelName }}</dd>
    </dl>
    <dl>
      <dt>통신사 변경 의향</dt>
      <dd>
        {{ convertCodeToName(item.telecomMaintance, TELECOM_MAINTANCE_ENUM) }}
      </dd>
    </dl>
    <dl>
      <dt>월 납부액</dt>
      <dd>{{ convertCodeToName(item.dataUsage, DATA_USAGE_ENUM) }}</dd>
    </dl>
    <dl>
      <dt>이용중인 인터넷</dt>
      <dd>
        {{ convertCodeToName(item.internetUsage, INTERNET_USAGE_ENUM) }}
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'EstimationCard',
  props: {
    item: Object,
  },
  data() {
    return {
      TARGET_NAME_ENUM: [
        { value: 1, name: '본인' },
        { value: 2, name: '부' },
        { value: 3, name: '모' },
        { value: 4, name: '자녀' },
      ],
      TELECOM_MAINTANCE_ENUM: [
        { value: 1, name: '네' },
        { value: 2, name: '아니오' },
        { value: 3, name: '모르겠음' },
      ],
      DATA_USAGE_ENUM: [
        { value: 1, name: '6만 원이상' },
        { value: 2, name: '4~5만 원대' },
        { value: 3, name: '3만 원대' },
        { value: 4, name: '3만 원 미만' },
        { value: 5, name: '모르겠음' },
      ],
      INTERNET_USAGE_ENUM: [
        { value: 1, name: 'SKB' },
        { value: 2, name: 'KT' },
        { value: 3, name: 'LGU' },
        { value: 4, name: '지역방송' },
        { value: 5, name: '모르겠음' },
        { value: 6, name: '이용안함' },
      ],
    };
  },
  computed: {
    currentModelName() {
      return this.item.currentModelName || '잘 모르겠음';
    },
  },
  methods: {
    convertCodeToName(value, type) {
      if (value) {
        return type.find(d => d.value === value).name;
      }
    },
  },
};
</script>
